"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEMailProvider = void 0;
var EEMailProvider;
(function (EEMailProvider) {
    EEMailProvider["SMTP"] = "SMTP";
})(EEMailProvider || (exports.EEMailProvider = EEMailProvider = {}));
